import React from "react";
import { PaymentSource } from "../../types";

type Props = {
  paymentSources: PaymentSource[];
  selectedId: string | null;
  onSelect: (id: string) => void;
};

export function PaymentSourcePicker({
  paymentSources,
  selectedId,
  onSelect,
}: Props) {
  return (
    <section
      className="rounded-lg border border-gray-200 dark:border-slate-700 p-4 space-y-2"
      data-testid="payment-source-picker"
    >
      <h3 className="text-base font-medium text-gray-900 dark:text-white">
        Pick a card
      </h3>
      {paymentSources.length === 0 ? (
        <p
          className="text-sm text-gray-500 dark:text-gray-400"
          data-testid="payment-source-picker-empty"
        >
          You don&apos;t have any cards on file yet. Add one below to continue.
        </p>
      ) : (
        <ul className="space-y-2">
          {paymentSources.map((src) => (
            <li key={src.paymentSourceId}>
              <label className="flex items-center gap-3 rounded-md border border-gray-200 dark:border-slate-700 p-3 cursor-pointer">
                <input
                  aria-label={`Card ending in ${src.last4 ?? "card"}`}
                  checked={selectedId === src.paymentSourceId}
                  name="payment-source"
                  onChange={() => onSelect(src.paymentSourceId)}
                  type="radio"
                  value={src.paymentSourceId}
                />
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">
                    {src.name ?? "Card"} ending in {src.last4 ?? "••••"}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    Expires {src.expMonth}/{src.expYear}
                  </p>
                </div>
              </label>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
